import {LOCATION_CHANGE} from 'redux-first-history';
import {paths} from '../../dictionaries/urls';
import {ActionTypes} from '../actions';
import createReducer from '../../util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  'selected': '',
  'expanded': true,
  'menuItems': [],
  'menuFavorite': [],
  'popularOptions': [],
  'favoriteOptions': [],
  'loadingFavorite': false,
  'loadingOptions': false,
  'isHidden': false,
};

const addFavoriteOption = (option, list) => {
  if (list.indexOf(option) === -1) {
    return [...list, option];
  }

  return list;
};

export const menu = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.UPDATE_MENU_NAVIGATION]: (state, action) => ({
      ...state,
      'selected': action.payload,
    }),
    [ActionTypes.TOGGLE_MENU_WIDTH]: (state, action) => ({
      ...state,
      'expanded': !state.expanded,
    }),
    [LOCATION_CHANGE]: (state, action) => {
      const {location} = action.payload;
      return {
        ...state,
        'isHidden':
          location.pathname === paths.PickingDashboard ||
          location.pathname === paths.LiquidationsList ||
          location.pathname.includes('/liquidaciones/detalle/'),
      };
    },
    [ActionTypes.ADD_ITEMS_TO_MENU]: (state, action) => ({
      ...state,
      'menuItems': _.union(INITIAL_STATE.menuItems, action.payload),
    }),
    [ActionTypes.GETTING_USER_OPTIONS]: (state, action) => ({
      ...state,
      'loadingOptions': true,
    }),
    [ActionTypes.GOTTEN_USER_OPTIONS]: (state, action) => ({
      ...state,
      'loadingOptions': false,
      ...action.response.data,
    }),
    [ActionTypes.GOTTEN_USER_OPTIONS_FAILED]: (state, action) => ({
      ...state,
      'loadingOptions': false,
    }),
    [ActionTypes.GETTING_FAVORITE_OPTIONS]: (state, action) => ({
      ...state,
      'loadingFavorite': true,
    }),
    [ActionTypes.GOTTEN_FAVORITE_OPTIONS]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
      'menuFavorite': action.response.data,
    }),
    [ActionTypes.GOTTEN_FAVORITE_OPTIONS_FAILED]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
    }),
    [ActionTypes.ADDING_FAVORITE_OPTION]: (state, action) => ({
      ...state,
      'loadingFavorite': true,
    }),
    [ActionTypes.ADDED_FAVORITE_OPTION]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
      'menuFavorite': addFavoriteOption(action.payload, state.menuFavorite),
    }),
    [ActionTypes.ADDED_FAVORITE_OPTION_FAILED]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
    }),
    [ActionTypes.REMOVING_FAVORITE_OPTION]: (state, action) => ({
      ...state,
      'loadingFavorite': true,
    }),
    [ActionTypes.REMOVED_FAVORITE_OPTION]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
      'menuFavorite': state.menuFavorite.filter(
        (option) => option !== action.payload
      ),
    }),
    [ActionTypes.REMOVED_FAVORITE_OPTION_FAILED]: (state, action) => ({
      ...state,
      'loadingFavorite': false,
    }),
  })(state, action);
};
